$(function () {
  const colorVariantsShort = $(".color-variants-short");
  const colorVariants = $(".color-variants");
  if (colorVariantsShort.length > 0) {
    colorVariants.addClass("hide");
  }
  $(".color-variants-short:eq(1)").addClass("hide");
  const variantsFull = $(".color-variants-full");
  const variantsShort = $(".color-variants-short");
  const readMore = $('.readmore');
  const readLess = $('.readless');

  readMore.click(function () {
    variantsFull.show();
    variantsShort.hide();
    readMore.hide();
    readLess.removeClass('hide');
    $(".color-variants-full:eq(1)").addClass("hide");
  });

  readLess.click(function () {
    variantsFull.hide();
    variantsShort.show();
    readMore.show();
    readLess.addClass('hide');
    $(".color-variants-short:eq(1)").addClass("hide");
    $(".color-variants-full:eq(1)").addClass("hide");
  });

  if (colorVariants.length > 1) {
    colorVariants.not(":first").addClass("hide");
  }

  const encodeData = (gid) => btoa(gid);
  // Get Swatch variant ID
  const swatchProduct = $(".product__submit--spb").attr("data-swatch-metafields");
  const encodedData = encodeData(swatchProduct);

  const productQuery = (gid) => `
    {
      node(id:"${gid}") {
        ...on Product {
          id
          title
          availableForSale
          variants(first: 5){
            edges{
              node{
                id
                image {
                  id
                  src
                }
              }
            }
          }
        }
      }
    }
  `;

  const STOREFRONT_ACCESS_TOKEN = "2eb0f290b40d0669bfd5875095e0078f";
  const GRAPHQL_URL = "https://halfpricedrapes-com.myshopify.com/api/2020-07/graphql.json";

  const GRAPHQL_BODY = (gid) => {
    return {
      async: true,
      crossDomain: true,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        "Content-Type": "application/graphql",
      },
      body: productQuery(gid),
    };
  };

  fetch(GRAPHQL_URL, GRAPHQL_BODY(encodedData))
    .then((res) => res.json())
    .then((product) => {
      if (product.data.node == null || product.data.node.availableForSale == false) {
        $(".product__submit__add-custom").css("display", "none");
      }

      if (product.data.node) {
        const encodedVariantID = product.data.node.variants.edges[0].node.id;
        const swatchVariantID = encodedVariantID.replace("gid://shopify/ProductVariant/", "");
        getProductId(swatchVariantID);
      }
    });

  const getCollectionSwatch = () => {
    let swatchGIDArr = [];
    $(".product-item__bg__under")
      .map(function () {
        swatchGIDArr.push($(this).data().swatch);
      })
      .get();

    for (let i = 0; i < swatchGIDArr.length; i++) {
      const encodedGID = encodeData(swatchGIDArr[i]);
      fetch(GRAPHQL_URL, GRAPHQL_BODY(encodedGID))
        .then((res) => res.json())
        .then((product) => {
          if (product.data) {
            const swatchImageSrc = product.data.node.variants.edges[0].node.image.src;
            $(`.product-item__bg__under--${i + 1}`).attr("data-bgset", swatchImageSrc);
          }
        });
    }
  };

  getCollectionSwatch();

  const getProductId = (swatchVariantID) => {
    $("#swatch-variant").attr("data-product-id", swatchVariantID);
    $(".product__submit__item input").val(swatchVariantID);
  };

  $(".product__submit__add-custom").prop("disabled", false);

  // set breadcrumb
  const breadCrumbCollection = $(".breadcrumbs-link");

  const breadCrumbTitle = localStorage.getItem("breadCrumbTitle", breadCrumbCollection.text());
  const breadCrumbLink = localStorage.getItem("breadCrumbLink", breadCrumbCollection.attr("href"));

  if (breadCrumbTitle && breadCrumbLink) {
    breadCrumbCollection.text(breadCrumbTitle);
    breadCrumbCollection.attr("href", breadCrumbLink);
    localStorage.clear();
  }

  $('.color-swatch-link').hover(function () {
    const swatchColor = $(this).attr("data-color");
    $('.swatch-color').addClass('hide');
    $('.item-code').append(`<span class="swatch-color mid-text">${swatchColor}<span>`);
  }, function () {
    $('.swatch-color').addClass('hide');
  });
});
